export default __webpack_public_path__ + "static/media/shoes1-afterA-2048w.26c95d10.webp";